export default "__VITE_ASSET__DCzY7ez3__"